import React from 'react';
import {createRoot} from 'react-dom/client'
import Routes from './Routes';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from './contexts/ConfigContext';
import './index.css'
import 'antd/dist/reset.css';
import { UserProvider } from './contexts/UserContext';
import { CompanyProvider } from './contexts/CompanyContext';
import { RegisterProvider } from './contexts/RegisterContext';
import { StoreProvider } from './contexts/StoreContext';
import { ContactProvider } from './contexts/ContactContext';
import { SWRConfig, mutate } from 'swr';
const domNode = document.getElementById('root') as HTMLElement

const root = createRoot(domNode)

root.render(
  <SWRConfig value={{
    onError: (error, key) => {
      if (error.status === 240) {
        // Find keys that look like token generation and mutate them
        mutate(
          (k) => Array.isArray(k) && typeof k[0] === 'string' && k[0].includes('/security/auth/'),
          undefined,
          { revalidate: true }
        )
      }
    }
  }}>
    <ConfigProvider>
      <UserProvider>
        <CompanyProvider>
          <RegisterProvider>
            <StoreProvider>
              <ContactProvider>
                <Routes/>
              </ContactProvider>
            </StoreProvider>
          </RegisterProvider>
        </CompanyProvider>
      </UserProvider>
    </ConfigProvider>
  </SWRConfig>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
